



























import { Component, Prop, Vue } from 'vue-property-decorator'

// Components
import UserType from '@/components/shared/UserType.vue'

@Component({
  components: { UserType },
})
export default class CategoryButtons extends Vue {
  @Prop()
  isCheckedPeople!: boolean

  @Prop()
  isCheckedThings!: boolean

  @Prop({ default: false })
  isHideLable!: boolean
}
